import { supabase } from './supabaseClient';
import { PriceAlerts } from './types';

// Memória de Preço
export const getItemPriceHistory = async (itemId: number, municipio?: string) => {
    const { data, error } = await supabase.rpc('get_item_price_history_by_municipio', {
        p_item_id: itemId,
        p_municipio: municipio && municipio !== 'Todos' ? municipio : null
    });
    if (error) throw error;
    return data;
};

export const getMunicipios = async () => {
    const { data, error } = await supabase.rpc('get_municipios');
    if (error) throw error;
    return (data.map((item: any) => item.municipio) as string[]) || [];
}

export const getPriceAlerts = async (threshold: number = 10): Promise<PriceAlerts> => {
    const { data, error } = await supabase.rpc('get_itens_alerta_precos', {
        p_threshold: threshold
    });
    if (error) throw error;
    return data;
};

export const updateSelicRates = async () => {
    const { data, error } = await supabase.functions.invoke('update-selic-rates');
    if (error) throw error;
    return data;
};

export const listUsers = async () => {
    const { data, error } = await supabase.functions.invoke('list-users');
    if (error) throw error;
    return data?.users || [];
};

export const getModulosAcessiveis = async (perfilNome: string): Promise<string[]> => {
    if (!perfilNome) {
        return [];
    }

    // 1. Fetch all profiles to find the ID for the given name
    const { data: perfis, error: perfisError } = await supabase.rpc('get_perfis');
    if (perfisError) {
        console.error('Error fetching profiles:', perfisError);
        return [];
    }

    const perfil = perfis.find((p: any) => p.nome === perfilNome);

    if (!perfil) {
        console.warn(`Profile with name '${perfilNome}' not found.`);
        return [];
    }

    // 2. Fetch the modules accessible by that profile ID
    const { data: modulos, error: modulosError } = await supabase.rpc('get_modulos_by_perfil', { p_perfil_id: perfil.id });
    if (modulosError) {
        console.error('Error fetching accessible modules:', modulosError);
        return [];
    }

    return modulos.map((m: any) => m.nome);
};
